import React from "react";
import {ContLogo} from "./styles";
import imgLogo from "../../assets/logo/logo1.png";

const logo = () => {
   return (
      <ContLogo>
         <div className="styleContLogo">
            <img className="styleLogo" alt="logo" src={imgLogo} />
         </div>
      </ContLogo>
   );
};

export default logo;
